import { clients } from "./clientsV2";
import { roles } from "./rolesV2";
import { users } from "./usersV2";
import { applications } from "./applicationsV2";
import { tags } from "./tagsV2";

export const apiV2 = {
  applications,
  users,
  clients,
  roles,
  tags,
};
